import React, {Component} from 'react';
import {DateTimePicker} from 'material-ui-pickers';

export default class DateAndTimePickers extends Component {

  render() {

    return (
      <div key="datetime_default" className="picker">

        <DateTimePicker
          fullWidth
          value={this.props.date}
          showTabs={false}
          onChange={this.props.handleDateChange}
          leftArrowIcon={<i className="zmdi zmdi-arrow-back"/>}
          rightArrowIcon={<i className="zmdi zmdi-arrow-forward"/>}
        />
      </div>)
  }
}